import { render, staticRenderFns } from "./InvalidVendor.vue?vue&type=template&id=2f31c92e&scoped=true&"
import script from "./InvalidVendor.vue?vue&type=script&lang=js&"
export * from "./InvalidVendor.vue?vue&type=script&lang=js&"
import style0 from "./InvalidVendor.vue?vue&type=style&index=0&id=2f31c92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31c92e",
  null
  
)

export default component.exports